import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { ConfirmationButtonComponent } from '../../confirmation-button/confirmation-button.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { FormatFileSizePipe } from '../format-file-size.pipe';

@Component({
  selector: 'moxi-upload-list',
  imports: [
    FormatFileSizePipe,
    ConfirmationButtonComponent,

    TranslatePipe,

    // Ant Design
    NzProgressModule,
    NzIconModule,
    NzButtonModule
  ],
  templateUrl: './upload-list.component.html',
  styleUrl: './upload-list.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class UploadListComponent {
  fileList = input.required<NzUploadFile[]>();
  isDisabled = input(false);

  removeFile = output<NzUploadFile>();
  downloadFile = output<NzUploadFile>();
}
